import React from 'react'
import { LoadingSpinnerMetaProps } from '../data/types'

type Props = {
    meta: LoadingSpinnerMetaProps
}

export const LoadingSpinner = (props: Props) => {
    const { meta } = props

    return (
        <div className="center flex-col gap-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-100"></div>
            <p className="text-gray-600 dark:text-gray-400">{meta.loadingText}</p>
        </div>
    )
}
